module.exports = __webpack_public_path__ + "img/MotorolaG10.84f94488.png";